// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfCrmUbosGetUbosByRelatieDto } from '../model/collectionResultOfCrmUbosGetUbosByRelatieDto.ts';

import type { CrmDomainDomainUbosUboContext } from '../model/crmDomainDomainUbosUboContext.ts';

import type { CrmUbosForceerUboResultaatForceerUboDto } from '../model/crmUbosForceerUboResultaatForceerUboDto.ts';

import type { CrmUbosUboDto } from '../model/crmUbosUboDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboInzien</li></ul>
 * @summary Haal de UBO's van een relatie op.
 */
export const uboGet = (
  relatieId: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatieId = toValue(relatieId);

  return customInstance<CollectionResultOfCrmUbosGetUbosByRelatieDto>(
    { url: `/api/v1/relaties/${relatieId}/ubo`, method: 'GET', signal },
    options,
  );
};

export const getUboGetQueryKey = (relatieId: MaybeRefOrGetter<string | undefined | null>) => {
  return ['api', 'v1', 'relaties', relatieId, 'ubo'] as const;
};

export const getUboGetQueryOptions = <
  TData = Awaited<ReturnType<typeof uboGet>>,
  TError = ErrorType<void>,
>(
  relatieId: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof uboGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getUboGetQueryKey(relatieId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof uboGet>>> = ({ signal }) =>
    uboGet(relatieId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(relatieId) !== null && toValue(relatieId) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof uboGet>>, TError, TData>;
};

export type UboGetQueryResult = NonNullable<Awaited<ReturnType<typeof uboGet>>>;
export type UboGetQueryError = ErrorType<void>;

/**
 * @summary Haal de UBO's van een relatie op.
 */

export function useUboGet<TData = Awaited<ReturnType<typeof uboGet>>, TError = ErrorType<void>>(
  relatieId: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof uboGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUboGetQueryOptions(relatieId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboAanmaken</li></ul>
 * @summary Maak een nieuwe UBO aan.
 */
export const uboCreate = (
  relatieId: MaybeRefOrGetter<string | undefined | null>,
  crmUbosUboDto?: MaybeRefOrGetter<CrmUbosUboDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatieId = toValue(relatieId);
  crmUbosUboDto = toValue(crmUbosUboDto);

  return customInstance<string>(
    {
      url: `/api/v1/relaties/${relatieId}/ubo`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmUbosUboDto,
      signal,
    },
    options,
  );
};

export const getUboCreateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboCreate>>,
    TError,
    UboCreateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboCreate>>,
  TError,
  UboCreateMutationVariables,
  TContext
> => {
  const mutationKey = ['uboCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboCreate>>,
    UboCreateMutationVariables
  > = (props) => {
    const { relatieId, data } = props ?? {};

    return uboCreate(relatieId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboCreateMutationResult = NonNullable<Awaited<ReturnType<typeof uboCreate>>>;
export type UboCreateMutationBody = CrmUbosUboDto | undefined;
export type UboCreateMutationError = ErrorType<void>;
export type UboCreateMutationVariables = {
  relatieId: string | undefined | null;
  data?: CrmUbosUboDto;
};

/**
 * @summary Maak een nieuwe UBO aan.
 */
export const useUboCreate = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboCreate>>,
      TError,
      UboCreateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboCreate>>,
  TError,
  UboCreateMutationVariables,
  TContext
> => {
  return useMutation(getUboCreateMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboBijwerken</li></ul>
 * @summary Werkt een bestaande UBO bij.
 */
export const uboUpdate = (
  uboId: MaybeRefOrGetter<string | undefined | null>,
  crmUbosUboDto?: MaybeRefOrGetter<CrmUbosUboDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = toValue(uboId);
  crmUbosUboDto = toValue(crmUbosUboDto);

  return customInstance<void>(
    {
      url: `/api/v1/ubo/${uboId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmUbosUboDto,
      signal,
    },
    options,
  );
};

export const getUboUpdateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboUpdate>>,
    TError,
    UboUpdateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboUpdate>>,
  TError,
  UboUpdateMutationVariables,
  TContext
> => {
  const mutationKey = ['uboUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboUpdate>>,
    UboUpdateMutationVariables
  > = (props) => {
    const { uboId, data } = props ?? {};

    return uboUpdate(uboId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof uboUpdate>>>;
export type UboUpdateMutationBody = CrmUbosUboDto | undefined;
export type UboUpdateMutationError = ErrorType<void>;
export type UboUpdateMutationVariables = {
  uboId: string | undefined | null;
  data?: CrmUbosUboDto;
};

/**
 * @summary Werkt een bestaande UBO bij.
 */
export const useUboUpdate = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboUpdate>>,
      TError,
      UboUpdateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboUpdate>>,
  TError,
  UboUpdateMutationVariables,
  TContext
> => {
  return useMutation(getUboUpdateMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboVerwijderen</li></ul>
 * @summary Verwijder een UBO.
 */
export const uboDelete = (
  uboId: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = toValue(uboId);

  return customInstance<void>({ url: `/api/v1/ubo/${uboId}`, method: 'DELETE', signal }, options);
};

export const getUboDeleteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboDelete>>,
    TError,
    UboDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboDelete>>,
  TError,
  UboDeleteMutationVariables,
  TContext
> => {
  const mutationKey = ['uboDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboDelete>>,
    UboDeleteMutationVariables
  > = (props) => {
    const { uboId } = props ?? {};

    return uboDelete(uboId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof uboDelete>>>;

export type UboDeleteMutationError = ErrorType<void>;
export type UboDeleteMutationVariables = { uboId: string | undefined | null };

/**
 * @summary Verwijder een UBO.
 */
export const useUboDelete = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboDelete>>,
      TError,
      UboDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboDelete>>,
  TError,
  UboDeleteMutationVariables,
  TContext
> => {
  return useMutation(getUboDeleteMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboCheck</li></ul>
 * @summary Voer UBO check uit.
 */
export const uboCheck = (
  uboId: MaybeRefOrGetter<string | undefined | null>,
  crmDomainDomainUbosUboContext?: MaybeRefOrGetter<CrmDomainDomainUbosUboContext>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = toValue(uboId);
  crmDomainDomainUbosUboContext = toValue(crmDomainDomainUbosUboContext);

  return customInstance<void>(
    {
      url: `/api/v1/ubo/${uboId}/check`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmDomainDomainUbosUboContext,
      signal,
    },
    options,
  );
};

export const getUboCheckMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboCheck>>,
    TError,
    UboCheckMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboCheck>>,
  TError,
  UboCheckMutationVariables,
  TContext
> => {
  const mutationKey = ['uboCheck'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboCheck>>,
    UboCheckMutationVariables
  > = (props) => {
    const { uboId, data } = props ?? {};

    return uboCheck(uboId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboCheckMutationResult = NonNullable<Awaited<ReturnType<typeof uboCheck>>>;
export type UboCheckMutationBody = CrmDomainDomainUbosUboContext | undefined;
export type UboCheckMutationError = ErrorType<void>;
export type UboCheckMutationVariables = {
  uboId: string | undefined | null;
  data?: CrmDomainDomainUbosUboContext;
};

/**
 * @summary Voer UBO check uit.
 */
export const useUboCheck = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboCheck>>,
      TError,
      UboCheckMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboCheck>>,
  TError,
  UboCheckMutationVariables,
  TContext
> => {
  return useMutation(getUboCheckMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboResultaatOverschrijven</li></ul>
 * @summary Forceer UBO resultaat als compliance medewerker.
 */
export const uboForceerResultaat = (
  uboId: MaybeRefOrGetter<string | undefined | null>,
  crmUbosForceerUboResultaatForceerUboDto?: MaybeRefOrGetter<CrmUbosForceerUboResultaatForceerUboDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = toValue(uboId);
  crmUbosForceerUboResultaatForceerUboDto = toValue(crmUbosForceerUboResultaatForceerUboDto);

  return customInstance<void>(
    {
      url: `/api/v1/ubo/${uboId}/forceer-resultaat`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmUbosForceerUboResultaatForceerUboDto,
      signal,
    },
    options,
  );
};

export const getUboForceerResultaatMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboForceerResultaat>>,
    TError,
    UboForceerResultaatMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboForceerResultaat>>,
  TError,
  UboForceerResultaatMutationVariables,
  TContext
> => {
  const mutationKey = ['uboForceerResultaat'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboForceerResultaat>>,
    UboForceerResultaatMutationVariables
  > = (props) => {
    const { uboId, data } = props ?? {};

    return uboForceerResultaat(uboId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboForceerResultaatMutationResult = NonNullable<
  Awaited<ReturnType<typeof uboForceerResultaat>>
>;
export type UboForceerResultaatMutationBody = CrmUbosForceerUboResultaatForceerUboDto | undefined;
export type UboForceerResultaatMutationError = ErrorType<void>;
export type UboForceerResultaatMutationVariables = {
  uboId: string | undefined | null;
  data?: CrmUbosForceerUboResultaatForceerUboDto;
};

/**
 * @summary Forceer UBO resultaat als compliance medewerker.
 */
export const useUboForceerResultaat = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboForceerResultaat>>,
      TError,
      UboForceerResultaatMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboForceerResultaat>>,
  TError,
  UboForceerResultaatMutationVariables,
  TContext
> => {
  return useMutation(getUboForceerResultaatMutationOptions(options), queryClient);
};
